import { getPricingOfAccountWhatsappCampaign } from "../types/account_campaign_pricing_whatsapp_types";

const initState = {
  data: [],
  loading: false,
  error: null,
};

export default function accountCampaignPricingWhatsappReducer(state = initState, action = {}) {
  switch (action.type) {
    case getPricingOfAccountWhatsappCampaign.GET_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getPricingOfAccountWhatsappCampaign.GET_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case getPricingOfAccountWhatsappCampaign.GET_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
